import { useTranslation } from 'react-i18next';

import { EmptyCartIcon } from '../assets/EmptyCart';

export const EmptyBasket = () => {
  const { t } = useTranslation();
  return (
    <div className="flex flex-col px-4 h-full pt-2">
      <p className="text-display-xl">{t('basket')}</p>
      <div className="flex flex-1 items-center justify-center flex-col space-y-4">
        <EmptyCartIcon className="h-[120px] w-[120px] shrink-0" />
        <div className="flex flex-col  space-y-1 text-center">
          <p className="text-body-base-medium text-text-secondary">
            {t('empty-basket')}
          </p>
          <p className="text-body-sm-regular text-text-secondary max-w-[160px]">
            {t('empty-basket-description')}
          </p>
        </div>
      </div>
    </div>
  );
};
